// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const LOOK_UP_STEP_SHAPES = [
  {
    stepType: PipelineStepType.LOOK_UP,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFrameName: {
        kind: 'string',
        required: true
      },
      lookupBy: {
        kind: 'enum',
        required: true,
        choices: [
          'id',
          'name',
          'barcode'
        ]
      },
      lookupColumn: {
        kind: 'columnReference',
        required: true,
        inputDataName: 'Input dataset',
        validationOptions: null
      },
      query: {
        kind: 'string',
        required: true
      },
      schemaId: {
        kind: 'string',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
